import {type MoneyResponseBody} from '@online-offer/shared';
import {useFormatCurrency} from 'platform/locale';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export const formatFinancialProductMoney = (
  money: MoneyResponseBody | Nullish,
  formatCurrency: ReturnType<typeof useFormatCurrency>
) => (isNil(money) ? null : formatCurrency(parseFloat(money.amount), money.currency));
